export default __webpack_public_path__ + "static/media/logo.dd685d89.svg";